import { render, staticRenderFns } from "./TeacherModal.vue?vue&type=template&id=890b8be4&"
import script from "./TeacherModal.vue?vue&type=script&lang=js&"
export * from "./TeacherModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports